export const GET_IMAGES = "GET_IMAGES";
export const SET_IMAGES = "SET_IMAGES";
export const ADD_IMAGE_TO_LIBRARY = "ADD_IMAGE_TO_LIBRARY";
export const DELETE_IMAGE = "DELETE_IMAGE";
export const SET_ERROR = "SET_ERROR";

export const get_images = (payload) => ({
  type: GET_IMAGES,
  payload,
});

export const set_images = (payload) => ({
  type: SET_IMAGES,
  payload,
});

export const add_image = (payload) => ({
  type: ADD_IMAGE_TO_LIBRARY,
  payload,
});

export const delete_image = (payload) => ({
  type: DELETE_IMAGE,
  payload,
});

export const set_error = (payload) => ({
  type: SET_ERROR,
  payload,
});
